import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_2 = {
  key: "save",
  class: "action-bar action-bar--save"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "action-bar__error",
  role: "alert"
}
const _hoisted_6 = {
  key: "dock",
  class: "app-dock"
}
const _hoisted_7 = { class: "nav-menu" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "icon-container" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "nav-badge nav-badge--mobile nav-badge--alert"
}
const _hoisted_12 = {
  key: 1,
  class: "nav-badge nav-badge--mobile nav-badge--upcoming"
}
const _hoisted_13 = {
  key: 2,
  class: "nav-dot nav-dot--new",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "nav-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalNavigationProgress = _resolveComponent("GlobalNavigationProgress")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AnalyticsConsentBanner = _resolveComponent("AnalyticsConsentBanner")!
  const _component_GlobalToastHost = _resolveComponent("GlobalToastHost")!
  const _component_GlobalSupportFab = _resolveComponent("GlobalSupportFab")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "app" }, {
    default: _withCtx(() => [
      _createVNode(_component_GlobalNavigationProgress),
      (!$setup.hideAppChrome)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.headerComponent), { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(['content-wrapper', { 'content-wrapper--fullbleed': $setup.hideAppChrome }])
        }, [
          _createVNode(_Transition, {
            name: "action-bar-morph",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              ($setup.showSaveBar && !$setup.hideAppDock)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "action-bar__cancel",
                      disabled: $setup.saveBarState.saving,
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onCancelClick && $setup.onCancelClick(...args)))
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-close")
                        ])),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString($setup.saveBarState.cancelLabel), 1)
                    ], 8, _hoisted_3),
                    _createElementVNode("button", {
                      type: "button",
                      class: "action-bar__save",
                      disabled: $setup.saveBarState.saving,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onSaveClick && $setup.onSaveClick(...args)))
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.saveBarState.saving
                                    ? 'mdi-loading mdi-spin'
                                    : 'mdi-content-save-check-outline'), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString($setup.saveBarState.saving ? 'Сохраняем…' : $setup.saveBarState.saveLabel), 1)
                    ], 8, _hoisted_4),
                    ($setup.saveBarState.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.saveBarState.error), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (!$setup.hideAppDock)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("nav", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navItems, (item) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: item.id,
                            class: _normalizeClass([
                                    'nav-item',
                                    {
                                        active: $setup.activeNavItem === item.id,
                                        'nav-item--alert':
                                            item.id === 'calendar' && $setup.calendarHasPendingHold,
                                    },
                                    `nav-item--${item.id}`,
                                ]),
                            onClick: ($event: any) => ($setup.handleNavItemClick(item.id))
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("span", {
                                class: "nav-icon-slot",
                                innerHTML: $setup.iconItems[item.id]
                              }, null, 8, _hoisted_10),
                              (item.id === 'calendar' && $setup.calendarHasPendingHold)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.calendarPendingHoldCount), 1))
                                : (item.id === 'calendar' && $setup.calendarUpcomingCount)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.calendarUpcomingCount), 1))
                                  : _createCommentVNode("", true),
                              (item.id === 'calendar' && $setup.calendarHasNew)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(item.text), 1)
                          ], 10, _hoisted_8))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("main", {
            class: _normalizeClass([
                        'main-content',
                        {
                            'main-content--fullbleed': $setup.hideAppChrome,
                            'main-content--dockless': $setup.hideAppDock,
                        },
                    ])
          }, [
            _createVNode(_component_router_view)
          ], 2),
          (!$setup.hideAppChrome)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.footerComponent), {
                key: 0,
                "is-admin": $setup.isAdmin
              }, null, 8, ["is-admin"]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createVNode(_component_AnalyticsConsentBanner),
      _createVNode(_component_GlobalToastHost),
      _createVNode(_component_GlobalSupportFab)
    ]),
    _: 1
  }))
}